import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Blocks } from 'lucide-react';

/** Where the rule builder lives. Signed out, the workbench sends a visitor to sign in and back (never a dead end). */
export const WORKBENCH_HREF = '/authoring/workbench';

/**
 * "Build your own rules" (issue 375): the homepage's way into the workbench, on the
 * visitor homepage and the signed-in dashboard alike. One line and one button.
 */
export default function BuildRulesTile({ headingClass = 'home-group-name', sectionClass = 'home-group' }) {
  return (
    <section className={sectionClass} aria-labelledby="home-build-rules-h" data-testid="home-build-rules">
      <h2 id="home-build-rules-h" className={headingClass}>Build your own rules</h2>
      <div className="home-tile" style={{ height: 'auto', flexWrap: 'wrap' }}>
        <span className="home-ring" aria-hidden="true"><Blocks /></span>
        <span className="home-tile-text" style={{ flex: '1 1 14rem' }}>
          <span className="home-tile-name">The workbench</span>
          {/* Its own line, not home-tile-desc: that one is hidden on a phone, and this tile is only its line. */}
          <span style={{ fontSize: '0.875rem', lineHeight: 1.35, color: 'var(--text-secondary)' }}>Make your own spells, feats and rules from building blocks</span>
        </span>
        <Link to={WORKBENCH_HREF} className="home-cta home-cta-gold" data-testid="home-build-rules-go">
          Open the workbench <ArrowRight aria-hidden="true" className="w-4 h-4 inline" />
        </Link>
      </div>
    </section>
  );
}
